module.exports = __webpack_public_path__ + "static/media/projects.6d05af58.webp";